// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"Cards_cardsContainer__ujPtq","linkStyles":"Cards_linkStyles__3KCsV"};